import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import moment from 'moment';
import {
    Typography, Stepper, Step, StepLabel, Table, TableBody, TableCell, TableContainer, TableFooter, TablePagination,
    TableRow, Paper, TableHead, Button, TextField, Box,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const columns = [
    { id: 'TrjNo', label: 'Transaction No', minWidth: 50 },
    { id: 'TrjDt', label: 'Date ', minWidth: 50 },
    { id: 'TrjType', label: 'Type', minWidth: 50 },
    // { id: 'TrjDt', label: 'Checkin Date ', minWidth: 50 },
    // { id: 'TrjDt', label: 'Checkout Date ', minWidth: 50 },
    // { id: 'TrjDt', label: 'Status ', minWidth: 50 },
];

const BookingHistory = ({ OpenHistoryTableDialog1, setOpenHistoryTableDialog1, rows }) => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchTerms, setSearchTerms] = useState({});
    console.log("History - data", rows);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset page to 0 when rows per page changes
    };
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    const handleClose = () => {
        setOpenHistoryTableDialog1(false);
        setTimeout(() => {
            setSearchTerms({});
            setPage(0);
        }, [500]);
    }

    const handleSearchChange = (columnId, value) => {
        setSearchTerms(prev => ({ ...prev, [columnId]: value }));
        setPage(0);
    };

    const filteredRows = React.useMemo(() => {
        return rows.filter(row => {
            return Object.entries(searchTerms).every(([columnId, term]) => {
                if (!term) return true;
                const value = row[columnId];
                if (typeof value === 'string') {
                    return value.toLowerCase().includes(term.toLowerCase());
                } else if (typeof value === 'number') {
                    return value.toString().includes(term);
                }
                return true;
            });
        });
    }, [searchTerms, rows]);

    return (
        <Dialog open={OpenHistoryTableDialog1} onClose={handleClose} maxWidth="lg" >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '16px 24px 8px 24px',
                    borderBottom: '1px solid #e0e0e0',
                }}
            >
                <DialogTitle sx={{ m: 0, p: 0 }}>Booking History</DialogTitle>
                <Button onClick={handleClose} color="primary" size="small">
                    <CloseIcon />
                </Button>
            </Box>

            <DialogContent>
                <Paper sx={{ width: '100%', overflow: 'hidden', border: '1px solid lightgray' }}>
                    <TableContainer sx={{ maxHeight: 300 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow
                                    sx={{
                                        '& > th': {
                                            padding: '2px  10px 2px  10px',
                                            textAlign: 'center'
                                        }
                                    }}
                                >
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth }}
                                        >
                                            <Typography variant="subtitle1" fontWeight="bold">
                                                {column.label}
                                            </Typography>
                                            <TextField
                                                size="small"
                                                variant="outlined"
                                                placeholder={`${column.label}`}
                                                onChange={(e) => handleSearchChange(column.id, e.target.value)}
                                                sx={{
                                                    mt: 1,
                                                    margin: '0px',
                                                    '& .MuiOutlinedInput-input': {
                                                        padding: '2px 6px',
                                                    },
                                                }}

                                            />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredRows
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => {
                                        // Create a unique key
                                        const uniqueKey = `${row.TrjNo}-${row.TrjDt}`;
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={index}
                                                // onDoubleClick={() => handleRowDoubleClick(row)}
                                                style={{ cursor: 'pointer' }}
                                                sx={{
                                                    '& > td': {
                                                        padding: '3px 10px 2px 19px',
                                                    }
                                                }}
                                            >
                                                {columns.map((column) => {
                                                    const value = row[column.id];
                                                    return (
                                                        <TableCell key={column.id} align={column.align}>
                                                            {column.id === "TrjDt" ? moment(value).format("DD-MM-YYYY") : value}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 15, 100]}
                        component="div"
                        count={filteredRows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            </DialogContent>
        </Dialog>
    )
}

export default BookingHistory
